"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MesoScripts = void 0;
var React = require("react");
var utils_1 = require("../utils");
var MesoScripts = function (props) {
  return React.createElement(React.Fragment, null, props.children, renderScripts(props.advertising));
};
exports.MesoScripts = MesoScripts;
var renderScripts = function (advertising) {
  var scripts = utils_1.getScripts();
  return scripts.map(function (script, index) {
    return React.createElement("script", __assign({}, script, {
      key: script.src || "script_" + index
    }));
  });
};